import React, { useState } from 'react';
import SaveButtonWithModal from '../SaveButtonWithModel';

const languages = [
  'Currently involved in Industry enterprise',
  'Have no experience but want to get involved in Industry enterprise',
  'Experienced in other industry enterprises',
  'Qualified but no experience. Want to get involved in Industry enterprises',
  'Experienced in other industry enterprises',
  'Have no experience. Want to get involved in Industry enterprises',
];

const GroupExperience = ({ selectedExperience = [], setSelectedExperience, onSave }) => {
  // Use the parent state if provided, otherwise local fallback (for preview/testing)
  const [internalSelected, setInternalSelected] = useState([]);
  const selected = setSelectedExperience ? selectedExperience : internalSelected;
  const setSelected = setSelectedExperience || setInternalSelected;

  const handleSelect = (lang) => {
    if (selected.includes(lang)) {
      setSelected(selected.filter(item => item !== lang));
    } else {
      setSelected([...selected, lang]);
    }
  };

  const handleSave = () => {
    if (onSave) {
      onSave({
        PersonalExperience: '    Personal, Group or Cooperative Experience', // replace with real value if available
        typeOfGroupExperience: 'Personal, Group or Cooperative Experience',
        selectedExperience: selected,
      });
    }
  };

  return (
    <div className='md:mt-2'>

      {/* Heading */}
      <div className='md:mt-6 mt-3'>
        <h1 className='md:text-[32px] text-[8px] font-bold'>
          Personal, Group or Cooperative Experience
        </h1>
        <p className='md:text-[24px] text-[6px] font-light italic'>
          Select your experience, special interests and vision for your involvement in industry.
        </p>
      </div>

      {/* Selectable Buttons */}
      <div className="grid grid-cols-2 md:gap-2 gap-1 md:mt-6 mt-2">
        {languages.map((lang, i) => {
          const isActive = selected.includes(lang);
          return (
            <button
              key={i}
              onClick={() => handleSelect(lang)}
              className={`
                flex items-center justify-between
                w-full md:h-[70px] h-[20px] text-left
                rounded-[5px]
                md:px-4 px-2
                bg-[#E7EBEB]
              `}
            >
              <span className="font-medium text-[4px] md:text-[24px] leading-[1.10] md:w-[500px]">{lang}</span>
              <span
                className={`
                  md:w-14 md:h-14 w-3 h-3 rounded-full
                  ${isActive 
                    ? 'bg-[#03897B] md:border-[8px] border-[3px] border-white'
                    : 'md:border-[8px] border-[3px] border-white bg-[#D9D9D9]'}
                `}
              />
            </button>
          );
        })}
      </div>

      <SaveButtonWithModal/>

      <div className="md:h-20 h-4"></div>
    </div>
  );
};

export default GroupExperience;